<div [formGroup]="form">
  <div formGroupName="onlineMoneyTransfer">
    <form-field class="front" label="Deposit" i18n-label="@@support.fiatDeposit.deposit.label">
      <ng-select [clearable]="false" [items]="deposits" formControlName="deposit" placeholder="Select your ticket type" i18n-placeholder="@@support.fiatDeposit.deposit.placeholder">
        <ng-template ng-option-tmp let-item="item" let-index="index">
          <div>#{{item?.id}}
          </div>
          <div>{{item?.amount?.amount | number:'0.2-2'}} {{item?.amount?.currency}} &nbsp; <span
              class="text-gray text-sm">{{item?.dateCreated | timestamp | date}}</span></div>
        </ng-template>
        <ng-template ng-label-tmp let-item="item">
          #{{item?.id}} - {{item?.amount?.amount | number:'0.2-2'}} {{item?.amount?.currency}}
        </ng-template>
      </ng-select>
    </form-field>

    <form-field class="front" label="Deposit Date" i18n-label="@@support.fiatDeposit.date.label">
      <input type="text" formControlName="transferDate" disabled="disabled" placeholder="Select a deposit to see its date here" i18n-placeholder="@@support.fiatDeposit.date.placeholder">
    </form-field>

    <div class="hline"></div>

    <form-field class="front" label="Bank Account Holder Name" i18n-label="@@support.fiatDeposit.bankHolderName.label">
      <input type="text" formControlName="bankAccountHolderName" placeholder="Enter the bank account holder name" i18n-placeholder="@@support.fiatDeposit.bankHolderName.placeholder">
    </form-field>

    <file-uploader [maxSize]="1024 * 5" [allowedTypes]="['png', 'jpg', 'jpeg', 'pdf']" (select)="onFileSelect($event)" (remove)="onFileRemove()"
      class="d-block mb-3">
      <input #file type="file" class="input">
      <ng-template #placeholder>
        <img src="assets/images/icons/upload-document.svg" alt="">
        <div class="text-primary pt-2 text-sm" i18n="@@support.fiatDeposit.paymentReceipt">Payment Receipt</div>
      </ng-template>
    </file-uploader>

    <form-field class="front textarea" label="Message" i18n-label="@@support.fiatDeposit.message.label">
      <textarea formControlName="message" placeholder="Enter your message" rows="5" i18n-placeholder="@@support.fiatDeposit.message.placeholder"></textarea>
    </form-field>
  </div>
</div>
